export default __webpack_public_path__ + "static/media/manish_baral.a63aa7fa.jpg";